/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_Frame_RateInputs */

const en_target_frame_rate = /** @type {(inputs: Target_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Frame Rate`)
};

const fr_target_frame_rate = /** @type {(inputs: Target_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fréquence d’images cible`)
};

const de_target_frame_rate = /** @type {(inputs: Target_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielbildrate`)
};

const it_target_frame_rate = /** @type {(inputs: Target_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequenza fotogrammi target`)
};

const ru_target_frame_rate = /** @type {(inputs: Target_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевая частота кадров`)
};

const es_target_frame_rate = /** @type {(inputs: Target_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad de fotogramas objetivo`)
};

const zh_cn2_target_frame_rate = /** @type {(inputs: Target_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标帧率`)
};

const ja_target_frame_rate = /** @type {(inputs: Target_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ターゲットフレームレート`)
};

const hi_target_frame_rate = /** @type {(inputs: Target_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्ष्य फ्रेम दर`)
};

const pt_pt2_target_frame_rate = /** @type {(inputs: Target_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de quadros alvo`)
};

/**
* | output |
* | --- |
* | "Target Frame Rate" |
*
* @param {Target_Frame_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_frame_rate = /** @type {((inputs?: Target_Frame_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_Frame_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_target_frame_rate(inputs)
	if (locale === "de") return de_target_frame_rate(inputs)
	if (locale === "it") return it_target_frame_rate(inputs)
	if (locale === "ru") return ru_target_frame_rate(inputs)
	if (locale === "es") return es_target_frame_rate(inputs)
	if (locale === "zh-CN") return zh_cn2_target_frame_rate(inputs)
	if (locale === "ja") return ja_target_frame_rate(inputs)
	if (locale === "hi") return hi_target_frame_rate(inputs)
	if (locale === "pt-PT") return pt_pt2_target_frame_rate(inputs)
	return en_target_frame_rate(inputs)
});